export enum EventCategoryEnum {
  ATELIER_PRATIQUE_ART = "ATELIER_PRATIQUE_ART",
  CINE_PLEIN_AIR = "CINE_PLEIN_AIR",
  CONCERT = "CONCERT",
  CONCOURS = "CONCOURS",
  CONFERENCE = "CONFERENCE",
  DECOUVERTE_METIERS = "DECOUVERTE_METIERS",
  EVENEMENT_CINE = "EVENEMENT_CINE",
  EVENEMENT_JEU = "EVENEMENT_JEU",
  EVENEMENT_MUSIQUE = "EVENEMENT_MUSIQUE",
  EVENEMENT_PATRIMOINE = "EVENEMENT_PATRIMOINE",
  FESTIVAL_ART_VISUEL = "FESTIVAL_ART_VISUEL",
  FESTIVAL_CINE = "FESTIVAL_CINE",
  FESTIVAL_LIVRE = "FESTIVAL_LIVRE",
  FESTIVAL_MUSIQUE = "FESTIVAL_MUSIQUE",
  FESTIVAL_SPECTACLE = "FESTIVAL_SPECTACLE",
  LIVESTREAM_EVENEMENT = "LIVESTREAM_EVENEMENT",
  LIVESTREAM_MUSIQUE = "LIVESTREAM_MUSIQUE",
  LIVESTREAM_PRATIQUE_ARTISTIQUE = "LIVESTREAM_PRATIQUE_ARTISTIQUE",
  RENCONTRE = "RENCONTRE",
  RENCONTRE_EN_LIGNE = "RENCONTRE_EN_LIGNE",
  RENCONTRE_JEU = "RENCONTRE_JEU",
  SALON = "SALON",
  SEANCE_CINE = "SEANCE_CINE",
  SEANCE_ESSAI_PRATIQUE_ART = "SEANCE_ESSAI_PRATIQUE_ART",
  SPECTACLE_REPRESENTATION = "SPECTACLE_REPRESENTATION",
  VISITE = "VISITE",
  VISITE_GUIDEE = "VISITE_GUIDEE",
}


export enum ShowTypeEnum {
  // Art de la rue
  ART_DE_LA_RUE_CARNAVAL = 'ART_DE_LA_RUE-CARNAVAL',
  ART_DE_LA_RUE_FANFARE = 'ART_DE_LA_RUE-FANFARE',
  ART_DE_LA_RUE_MIME = 'ART_DE_LA_RUE-MIME',
  ART_DE_LA_RUE_PARADE = 'ART_DE_LA_RUE-PARADE',
  ART_DE_LA_RUE_THEATRE_DE_RUE = 'ART_DE_LA_RUE-THEATRE_DE_RUE',
  ART_DE_LA_RUE_THEATRE_PROMENADE = 'ART_DE_LA_RUE-THEATRE_PROMENADE',
  ART_DE_LA_RUE_OTHER = 'ART_DE_LA_RUE-OTHER',

  // Cirque
  CIRQUE_CIRQUE_CONTEMPORAIN = 'CIRQUE-CIRQUE_CONTEMPORAIN',
  CIRQUE_CIRQUE_HORS_LES_MURS = 'CIRQUE-CIRQUE_HORS_LES_MURS',
  CIRQUE_CIRQUE_TRADITIONNEL = 'CIRQUE-CIRQUE_TRADITIONNEL',
  CIRQUE_CIRQUE_VOYAGEUR = 'CIRQUE-CIRQUE_VOYAGEUR',
  CIRQUE_CLOWN = 'CIRQUE-CLOWN',
  CIRQUE_HYPNOSE = 'CIRQUE-HYPNOSE',
  CIRQUE_MENTALISTE = 'CIRQUE-MENTALISTE',
  CIRQUE_SPECTACLE_DE_MAGIE = 'CIRQUE-SPECTACLE_DE_MAGIE',
  CIRQUE_SPECTACLE_EQUESTRE = 'CIRQUE-SPECTACLE_EQUESTRE',
  CIRQUE_OTHER = 'CIRQUE-OTHER',

  // Danse
  DANSE_BALLET = 'DANSE-BALLET',
  DANSE_CANCAN = 'DANSE-CANCAN',
  DANSE_CLAQUETTE = 'DANSE-CLAQUETTE',
  DANSE_CLASSIQUE = 'DANSE-CLASSIQUE',
  DANSE_CONTEMPORAINE = 'DANSE-CONTEMPORAINE',
  DANSE_DANSE_DU_MONDE = 'DANSE-DANSE_DU_MONDE',
  DANSE_FLAMENCO = 'DANSE-FLAMENCO',
  DANSE_MODERNE_JAZZ = 'DANSE-MODERNE_JAZZ',
  DANSE_SALSA = 'DANSE-SALSA',
  DANSE_SWING = 'DANSE-SWING',
  DANSE_TANGO = 'DANSE-TANGO',
  DANSE_URBAINE = 'DANSE-URBAINE',
  DANSE_OTHER = 'DANSE-OTHER',

  // Humour
  HUMOUR_CAFE_THEATRE = 'HUMOUR-CAFE_THEATRE',
  HUMOUR_IMPROVISATION = 'HUMOUR-IMPROVISATION',
  HUMOUR_SEUL_EN_SCENE = 'HUMOUR-SEUL_EN_SCENE',
  HUMOUR_SKETCH = 'HUMOUR-SKETCH',
  HUMOUR_STAND_UP = 'HUMOUR-STAND_UP',
  HUMOUR_VENTRILOQUE = 'HUMOUR-VENTRILOQUE',
  HUMOUR_OTHER = 'HUMOUR-OTHER',

  // Spectacle musical
  SPECTACLE_MUSICAL_CABARET = 'SPECTACLE_MUSICAL-CABARET',
  SPECTACLE_MUSICAL_CAFE_CONCERT = 'SPECTACLE_MUSICAL-CAFE_CONCERT',
  SPECTACLE_MUSICAL_CLAQUETTE = 'SPECTACLE_MUSICAL-CLAQUETTE',
  SPECTACLE_MUSICAL_COMEDIE_MUSICALE = 'SPECTACLE_MUSICAL-COMEDIE_MUSICALE',
  SPECTACLE_MUSICAL_OPERA_BOUFFE = 'SPECTACLE_MUSICAL-OPERA_BOUFFE',
  SPECTACLE_MUSICAL_OPERETTE = 'SPECTACLE_MUSICAL-OPERETTE',
  SPECTACLE_MUSICAL_REVUE = 'SPECTACLE_MUSICAL-REVUE',
  SPECTACLE_MUSICAL_BURLESQUE = 'SPECTACLE_MUSICAL-BURLESQUE',
  SPECTACLE_MUSICAL_COMEDIE_BALLET = 'SPECTACLE_MUSICAL-COMEDIE_BALLET',
  SPECTACLE_MUSICAL_OPERA_COMIQUE = 'SPECTACLE_MUSICAL-OPERA_COMIQUE',
  SPECTACLE_MUSICAL_OPERA_BALLET = 'SPECTACLE_MUSICAL-OPERA_BALLET',
  SPECTACLE_MUSICAL_THEATRE_MUSICAL = 'SPECTACLE_MUSICAL-THEATRE_MUSICAL',
  SPECTACLE_MUSICAL_OTHER = 'SPECTACLE_MUSICAL-OTHER',

  // Spectacle jeunesse
  SPECTACLE_JEUNESSE_CONTE = 'SPECTACLE_JEUNESSE-CONTE',
  SPECTACLE_JEUNESSE_THEATRE_JEUNESSE = 'SPECTACLE_JEUNESSE-THEATRE_JEUNESSE',
  SPECTACLE_JEUNESSE_SPECTACLE_PETITE_ENFANCE = 'SPECTACLE_JEUNESSE-SPECTACLE_PETITE_ENFANCE',
  SPECTACLE_JEUNESSE_MAGIE_ENFANCE = 'SPECTACLE_JEUNESSE-MAGIE_ENFANCE',
  SPECTACLE_JEUNESSE_SPECTACLE_PEDAGOGIQUE = 'SPECTACLE_JEUNESSE-SPECTACLE_PEDAGOGIQUE',
  SPECTACLE_JEUNESSE_MARIONETTES = 'SPECTACLE_JEUNESSE-MARIONETTES',
  SPECTACLE_JEUNESSE_COMEDIE_MUSICALE_JEUNESSE = 'SPECTACLE_JEUNESSE-COMEDIE_MUSICALE_JEUNESSE',
  SPECTACLE_JEUNESSE_THEATRE_D_OMBRES = 'SPECTACLE_JEUNESSE-THEATRE_D_OMBRES',
  SPECTACLE_JEUNESSE_OTHER = 'SPECTACLE_JEUNESSE-OTHER',

  // Théâtre
  THEATRE_BOULEVARD = 'THEATRE-BOULEVARD',
  THEATRE_CLASSIQUE = 'THEATRE-CLASSIQUE',
  THEATRE_COMEDIE = 'THEATRE-COMEDIE',
  THEATRE_CONTEMPORAIN = 'THEATRE-CONTEMPORAIN',
  THEATRE_LECTURE = 'THEATRE-LECTURE',
  THEATRE_SPECTACLE_SCENOGRAPHIQUE = 'THEATRE-SPECTACLE_SCENOGRAPHIQUE',
  THEATRE_THEATRE_EXPERIMENTAL = 'THEATRE-THEATRE_EXPERIMENTAL',
  THEATRE_THEATRE_D_OBJET = 'THEATRE-THEATRE_D_OBJET',
  THEATRE_TRAGEDIE = 'THEATRE-TRAGEDIE',
  THEATRE_OTHER = 'THEATRE-OTHER',

  // Pluridisciplinaire
  PLURIDISCIPLINAIRE_PERFORMANCE = 'PLURIDISCIPLINAIRE-PERFORMANCE',
  PLURIDISCIPLINAIRE_POESIE = 'PLURIDISCIPLINAIRE-POESIE',
  PLURIDISCIPLINAIRE_OTHER = 'PLURIDISCIPLINAIRE-OTHER',

  // Opéra
  OPERA_OPERA_SERIE = 'OPERA-OPERA_SERIE',
  OPERA_GRAND_OPERA = 'OPERA-GRAND_OPERA',
  OPERA_OPERA_BOUFFE = 'OPERA-OPERA_BOUFFE',
  OPERA_OPERA_COMIQUE = 'OPERA-OPERA_COMIQUE',
  OPERA_OPERA_BALLET = 'OPERA-OPERA_BALLET',
  OPERA_SINGSPIEL = 'OPERA-SINGSPIEL',
  OPERA_OTHER = 'OPERA-OTHER',

  // Other
  OTHER_SON_ET_LUMIERE = 'OTHER-SON_ET_LUMIERE',
  OTHER_SPECTACLE_SUR_GLACE = 'OTHER-SPECTACLE_SUR_GLACE',
  OTHER_SPECTACLE_HISTORIQUE = 'OTHER-SPECTACLE_HISTORIQUE',
  OTHER_SPECTACLE_AQUATIQUE = 'OTHER-SPECTACLE_AQUATIQUE',
  OTHER_OTHER = 'OTHER-OTHER',
  OTHER = 'OTHER',
}

export enum MusicTypeEnum {
  MUSIQUE_CLASSIQUE = "MUSIQUE_CLASSIQUE",
  JAZZ_BLUES = "JAZZ_BLUES",
  ELECTRO = "ELECTRO",
  POP = "POP",
  ROCK = "ROCK",
  METAL = "METAL",
  ALTERNATIF = "ALTERNATIF",
  VARIETES = "VARIETES",
  FUNK_SOUL_RNB_DISCO = "FUNK_SOUL_RNB_DISCO",
  RAP_HIP_HOP = "RAP_HIP_HOP",
  REGGAE_RAGGA = "REGGAE_RAGGA",
  MUSIQUE_DU_MONDE = "MUSIQUE_DU_MONDE",
  COUNTRY_FOLK = "COUNTRY_FOLK",
  AMBIANCE = "AMBIANCE",
  AUTRES = "AUTRES",
}

export type EventCategory = keyof typeof EventCategoryEnum;
export type ShowType = keyof typeof ShowTypeEnum;
export type MusicType = keyof typeof MusicTypeEnum;

export interface IEventOffer {
  id: number;
  name?: string;
  accessibility: {
    audioDisabilityCompliant: boolean;
    mentalDisabilityCompliant: boolean;
    motorDisabilityCompliant: boolean;
    visualDisabilityCompliant: boolean;
  }
  bookingAllowedDatetime: string;
  bookingContact: string;
  bookingEmail: string;
  categoryRelatedFields: {
      category: EventCategory;
      showType: ShowType;
      musicType: MusicType;
      author: string;
      performer: string;
      stageDirector: string;
      speaker: string;
      visa: string;
    }
  description: string;
  enableDoubleBookings: boolean;
  eventDuration: number;
  externalTicketOfficeUrl: string;
  hasTicket: boolean;
  idAtProvider: string;
  image: {
    credit: string;
    url: string;
  }
  itemCollectionDetails: null
  location: {}
  priceCategories: IPriceCategory[]
  publicationDatetime: string;
  status: string;
}

export interface IPriceCategory {
  id: number;
  idAtProvider: string;
  label: string;
  price: number;
}